import { AppForm, Maintenance } from '@workspace/core-ts/components';
import { initDataLayer, sentryInit } from '@workspace/utils';
import ReactDOM from 'react-dom/client';
import veloFormConfig from '@/config/form-config';
import { VeloStateResolver } from '@/config/velo-state-resolver';
import initialState from './initial-state';
import steps from './steps';
import './styles/global.css';

const APP_ENV = import.meta.env.MODE || 'production';

initDataLayer(APP_ENV);
sentryInit();

const isMaintenance = window.location.pathname === '/maintenance';

ReactDOM.createRoot(document.getElementById('root')!).render(
  isMaintenance ? (
    <Maintenance />
  ) : (
    <AppForm
      initialFormState={initialState}
      origin="direct"
      steps={steps}
      config={veloFormConfig}
      stateResolver={new VeloStateResolver()}
    />
  ),
);
